const list = [
    {
      id: 1,
      title: "Fresh bananas",
      price: 50,
      img: "https://imgs.search.brave.com/Ma2UmbADyLlVL8ua3A9540mZPakNP7B49yeYaOK2fvc/rs:fit:900:665:1/g:ce/aHR0cDovL3BhbXNk/YWlseWRpc2guY29t/L3dwLWNvbnRlbnQv/dXBsb2Fkcy8yMDE1/LzA0L0J1bmNoLUJh/bmFuYXMtMi5qcGc",
      amount: 1,
    },
    {
      id: 2,
      title: "Apples",
      price: 150,
      img: "https://imgs.search.brave.com/C5t_Ool9LUUljjojNhM03XB9xLjPT0v0LW_RXlL3BJY/rs:fit:1200:1200:1/g:ce/aHR0cDovL2RyZWFt/aWN1cy5jb20vZGF0/YS9hcHBsZS9hcHBs/ZS0wNS5qcGc",
      amount: 1,
    },
    {
      id: 3,
      title: "Amazing Avocadoes",
      price: 35,
      img: "https://imgs.search.brave.com/jLJM5X-xIm9_U_TAAro3xjtMW6rZQgB_95tKbZsv7BM/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly9pbWFn/ZXMuanVtcHNlbGxl/ci5jb20vc3RvcmUv/bGEtY2FycmV0YS1z/dXBlcm1hcmtldHMx/LzUzMTkyMDIvQVZP/Q0FET19MR18xMjM4/WDEyMTUuZ2lmPzE1/OTY1NjgxNjI.gif",
      amount: 1,
    },
    {
      id: 4,
      title: "Onions",
      price: 35,
      img: "https://imgs.search.brave.com/KX8yEIuMabo_WImMijgi2ZHsZbkl-KP2W1X-adghQTQ/rs:fit:1000:1000:1/g:ce/aHR0cHM6Ly9wcmFt/b2RhLmNvLmluL3dw/LWNvbnRlbnQvdXBs/b2Fkcy8yMDIwLzA2/L1NldC0xMDAwLmpw/Zw",
      amount: 1,
    },
    {
      id: 5,
      title: "Sweet Papayas",
      price: 50,
      img: "https://imgs.search.brave.com/pZvhyCc9oXEkqSTvbFWL94xGbyyMK8weXGgVazepbUU/rs:fit:1024:1024:1/g:ce/aHR0cHM6Ly93d3cu/ZnJ1aXR0cm9waWNh/bC5jb20vd3AtY29u/dGVudC91cGxvYWRz/L3BhcGF5YS5qcGc",
      amount: 1,
    },
    {
      id: 6,
      title: "Fresh Tomatoes",
      price: 55,
      img: "https://imgs.search.brave.com/izGxv3n-xhd-hwsx8TqGNPlx9v0bazn6gjYImXehDsw/rs:fit:1200:1129:1/g:ce/aHR0cHM6Ly93d3cu/bGlwbWFuZmFtaWx5/ZmFybXMuY29tL3dw/LWNvbnRlbnQvdXBs/b2Fkcy8yMDIwLzA5/L1RPVi1oZXJvQDJ4/LnBuZw",
      amount: 1,
    },
    {
      id: 7,
      title: "Fresh potatoes",
      price: 15,
      img: "https://imgs.search.brave.com/1cC8-4qAGP4K5VH9o3qb9zeaLK-iiBg3m8V9MJpoKsE/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly9wdXJl/cG5nLmNvbS9wdWJs/aWMvdXBsb2Fkcy9s/YXJnZS9wdXJlcG5n/LmNvbS1wb3RhdG9w/b3RhdG9mb29kLWNy/b3BzdmVnZXRhYmxl/cG90YXRvcy0xNzAx/NTI3MzExMzg1enJ6/Y2kucG5n",
      amount: 1,
    },
    {
      id: 8,
      title: "sweet oranges",
      price: 80,
      img: "https://imgs.search.brave.com/6lvxVj0Lr--kxwDp7qnS_GvAE-eTWLfPPyIL4pYHuVk/rs:fit:510:510:1/g:ce/aHR0cHM6Ly9wdXJl/cG5nLmNvbS9wdWJs/aWMvdXBsb2Fkcy9s/YXJnZS9wdXJlcG5n/LmNvbS1vcmFuZ2Vv/cmFuZ2VmcnVpdGJp/dHRlci1vcmFuZ2Vv/cmFuZ3MtMTcwMTUy/NzMzNjE0MmdqczA3/LnBuZw",
      amount: 1,
    },
    {
      id: 9,
      title: "Fresh Carrots",
      price: 30,
      img: "https://imgs.search.brave.com/YSgpMRnee9Yy476yF7t9t4BglWZ133eSQYc1Bx-POAQ/rs:fit:1200:1200:1/g:ce/aHR0cDovL3B1cmVw/bmcuY29tL3B1Ymxp/Yy91cGxvYWRzL2xh/cmdlL3B1cmVwbmcu/Y29tLWNhcnJvdHNj/YXJyb3R2ZWdldGFi/bGVzZnJlc2hkZWxp/Y2lvdXNlZm9vZGhl/YWx0aHljYXJyb3Rz/LTQ4MTUyMTc0MDcx/N2ptZ2xxLnBuZw",
      amount: 1,
    },
    {
      id: 10,
      title: "Beetroots",
      price: 30,
      img: "https://imgs.search.brave.com/axRauUfrhUKtN3Vy5OZbywIRKdDav89NqZnN9qoJIlI/rs:fit:1087:1087:1/g:ce/aHR0cHM6Ly9iaXZp/YW5vZGlyZWN0LmNv/bS5hdS93cC1jb250/ZW50L3VwbG9hZHMv/MjAyMC8wNy9wcm9k/dWN0cy1BNkQwREY3/Mi04NzIyLTQ3NEIt/QkE5My00NTA3MUEw/Qzc1NTlfZDY2MTcy/YWUtYjk0Ni00ZTkz/LTlmZDktZjcyNzA3/ZGE1MjBhLmpwZw",
      amount: 1,
    },
    {
      id: 11,
      title: "Cabbages",
      price: 20,
      img: "https://imgs.search.brave.com/oeLm2IhWtRPGXLssgZBkSvl96oFVMM0rgiZMcJa8wfc/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly93d3cu/ZnJlc2hwb2ludC5j/b20vd3AtY29udGVu/dC91cGxvYWRzLzIw/MjAvMDIvRnJlc2hw/b2ludC1ncmVlbi1j/YWJiYWdlLmpwZw",
      amount: 1,
    },
    {
      id: 12,
      title: "Lemmons",
      price: 60,
      img: "https://imgs.search.brave.com/glA11woZBMnaDsWu5WPZhE9jFiNNDSJaD63kriFxwng/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly93d3cu/cG5nYWxsLmNvbS93/cC1jb250ZW50L3Vw/bG9hZHMvMjAxNi8w/NS9MZW1vbi1QTkct/SEQucG5n",
      amount: 1,
    },
    {
      id: 13,
      title: "ziccuhini",
      price: 50,
      img: "https://imgs.search.brave.com/1NkEUJMNArrCE4_6fiJHS1VP2wX4In9FbrJcF4--bwU/rs:fit:843:583:1/g:ce/aHR0cHM6Ly93d3cu/cGVydGhvcmdhbmlj/cy5jb20vYXNzZXRz/L2Z1bGwvNTM2Lmpw/Zw",
      amount: 1,
    },
    {
      id: 14,
      title: "Cucumber",
      price: 60,
      img: "https://imgs.search.brave.com/LulAP61EJfokPP7T99Sq05q65z1mgfoL2r9m46mbaBE/rs:fit:1200:991:1/g:ce/aHR0cHM6Ly93d3cu/bGlwbWFuZmFtaWx5/ZmFybXMuY29tL3dw/LWNvbnRlbnQvdXBs/b2Fkcy8yMDIwLzA5/L01pbmlDdWN1bWJl/ci1oZXJvQDJ4LnBu/Zw",
      amount: 1,
    },
    {
      id: 15,
      title: "Eggplant",
      price: 45,
      img: "https://imgs.search.brave.com/AYThYzufZwAvmjhu5cXtb48FdAzSyDW1yJ1fSo3bUls/rs:fit:872:617:1/g:ce/aHR0cDovL3d3dy5z/cGVjaWFsdHlwcm9k/dWNlLmNvbS9zcHBp/Y3MvMTYzNDYucG5n",
      amount: 1,
    },
    {
      id: 16,
      title: "Lettuce",
      price: 35,
      img: "https://imgs.search.brave.com/v0tVO2iLOtrkctm2q4-P9KyskDd9Eg7PdcY14p9MIMQ/rs:fit:1200:960:1/g:ce/aHR0cHM6Ly93d3cu/ZmFybWl6ZW4uY29t/L3dwLWNvbnRlbnQv/dXBsb2Fkcy8yMDE3/LzA3L0xldHR1Y2Vf/cmVmaWxsXzEyMDB4/OTYwLmpwZw",
      amount: 1,
    },
    {
      id: 17,
      title: "Ginger",
      price: 80,
      img: "https://imgs.search.brave.com/wu5gbAMzLCMVqX0xdK7ofrsk1OVbx3otCj1oEvvVmlA/rs:fit:1200:1200:1/g:ce/aHR0cDovL21vbXdp/dGhhcHJlcC5jb20v/d3AtY29udGVudC91/cGxvYWRzLzIwMTgv/MDUvRGVwb3NpdHBo/b3Rvc181MzMyNjk1/N19sLTIwMTUuanBn",
      amount: 1,
    },
    {
      id: 18,
      title: "Pepper",
      price: 80,
      img: "https://imgs.search.brave.com/pAyU1dsNSX--w0U1R8cJIAFf6rRKznC2jvXgCb9rmXY/rs:fit:872:1000:1/g:ce/aHR0cDovL21lZGlq/dWljZS5jb20vd3At/Y29udGVudC91cGxv/YWRzLzIwMTcvMDcv/cGVwcGVyLTEtMS5q/cGc",
      amount: 1,
    },
    {
      id: 19,
      title: "Strawberries",
      price: 80,
      img: "https://imgs.search.brave.com/JAk2sSYLmoZ5Ir0o3Y7RhFgs3Vz-Ru9yG5D42MtCzSY/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly93YWxs/c2Rlc2suY29tL3dw/LWNvbnRlbnQvdXBs/b2Fkcy8yMDE3LzAx/L1N0cmF3YmVycnkt/RnJlZS1Eb3dubG9h/ZC5qcGc",
      amount: 1,
    },
    {
      id: 20,
      title: "Garlic",
      price: 120,
      img: "https://imgs.search.brave.com/KFoKYYjO-hWf-G8cyvPXck_zXH0PrL-yARUU5bGIpaM/rs:fit:1200:1200:1/g:ce/aHR0cHM6Ly93d3cu/b3JnYW5pY2xpZmVz/dHlsZW1hZ2F6aW5l/LmNvbS93cC1jb250/ZW50L3VwbG9hZHMv/MjAxNC8wNS9HYXJs/aWMuanBlZw",
      amount: 1,
    },
  ];
  
  export default list;